(function () {
  function initStickyHeader() {
    var productsRow = document.querySelector('.price-features_products');
    var layout = document.querySelector('.price-features_layout');
    if (!productsRow || !layout) return;

    var headerInner = document.querySelector('.header__inner');
    var newbar = document.querySelector('[id^="shopify-section-announcement_newbar"]');

    var isSticky = false;
    var originalTop = 0;
    var layoutTop = 0;
    var layoutBottom = 0;

    function setHidden(hidden) {
      if (headerInner) headerInner.style.display = hidden ? 'none' : '';
      if (newbar) newbar.style.display = hidden ? 'none' : '';
    }

    function updatePositions() {
      var layoutRect = layout.getBoundingClientRect();
      layoutTop = layoutRect.top + window.pageYOffset;
      layoutBottom = layoutTop + layout.offsetHeight;
      if (!isSticky) {
        originalTop = productsRow.getBoundingClientRect().top + window.pageYOffset;
      }
    }

    function handleScroll() {
      var scrollTop = window.pageYOffset;
      var productsHeight = productsRow.offsetHeight;
      var layoutRect = layout.getBoundingClientRect();

      if (scrollTop >= originalTop && scrollTop + productsHeight <= layoutBottom) {
        productsRow.style.position = 'fixed';
        productsRow.style.top = '0';
        productsRow.style.left = layoutRect.left + 'px';
        productsRow.style.width = layout.offsetWidth + 'px';
        productsRow.style.right = '';
        isSticky = true;
      } else if (scrollTop + productsHeight > layoutBottom) {
        productsRow.style.position = 'absolute';
        productsRow.style.top = (layoutBottom - layoutTop - productsHeight) + 'px';
        productsRow.style.left = '0';
        productsRow.style.right = '0';
        productsRow.style.width = '';
        isSticky = false;
      } else {
        productsRow.style.position = '';
        productsRow.style.top = '';
        productsRow.style.left = '';
        productsRow.style.right = '';
        productsRow.style.width = '';
        isSticky = false;
      }

      setHidden(isSticky);
    }

    updatePositions();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { handleScroll(); ticking = false; });
        ticking = true;
      }
    });
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        isSticky = false;
        setHidden(false);
        ['position', 'top', 'left', 'right', 'width'].forEach(function (p) {
          productsRow.style[p] = '';
        });
        updatePositions();
        handleScroll();
      }, 100);
    });
    handleScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyHeader);
  } else {
    initStickyHeader();
  }
})();
